// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__vG8JQ","top":"Menu_top__8bYcM","toggle":"Menu_toggle__CG3q1","icon":"Menu_icon__9CMa1"};